module.exports = __webpack_public_path__ + "static/media/slide1.981ecf14.jpg";